import requester from '@/lib/axios';
import { OrderingFrom } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import StudentExam, {
  StudentExamCorrectionStatusEnum,
} from '@/models/StudentExam';

export const STUDENT_EXAM_ORDERING_FIELDS = ['finished_at'] as const;

export type StudentExamOrdering = OrderingFrom<
  typeof STUDENT_EXAM_ORDERING_FIELDS
>;

export interface StudentExamFilterParams extends BaseFilters {
  pageNumber?: number;
  pageSize?: number;
  klassId?: number[];
  examId?: number[];
  studentId?: number[];
  teacherId?: number[];
  unitId?: number[];
  courseId?: number[];
  finishedAtAfter?: string;
  finishedAtBefore?: string;
  status?: StudentExamCorrectionStatusEnum[];
  ordering?: StudentExamOrdering;
}

export async function listStudentExams(params: StudentExamFilterParams = {}) {
  const { data } = await requester().get<JsonApiResponse<StudentExam>>(
    'student-exams/',
    {
      params,
    },
  );

  return data;
}
